import React from "react";
import Container from "@mui/material/Container";
import { styled } from "@mui/material";

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: 30,
  [theme.breakpoints.down("xs")]: {
    marginTop: 50,
  },
}));

const ContentContainer = ({ children }) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default ContentContainer;
